import Joi from "joi";

function ValidateTalhao(talhao) {
  const schema = Joi.object({
    nome: Joi.string().trim().max(100).required().messages({
      "string.empty": "Nome do talhão é obrigatório",
      "string.max": "Nome do talhão deve ter no máximo 100 caracteres",
      "any.required": "Nome do talhão é obrigatório",
    }),
  }).unknown(true);

  const { error } = schema.validate(talhao, { abortEarly: false });

  return error?.details?.map((item) => ({
    message: item.message,
    keyError: item.path[0],
    type: item.type.split(".")[1],
  }));
}

export { ValidateTalhao };
